import { ApiHandler, createHandlerChainRunner, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetDealerByPathApiParameter } from "@insite/client-framework/Services/DealerService";
import { get } from "@insite/client-framework/Services/ApiService";
import { DealerModel } from "@insite/client-framework/Types/ApiModels";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Dealers/Handlers/LoadDealerByPath";

type HandlerType = ApiHandler<GetDealerByPathApiParameter, DealerModel>;

export const RequestDataFromApiUpdated: HandlerType = async props => {
    try {
        props.apiResult = await get<DealerModel>(
            "/api/v1/dealers/getbypath/",
            props.apiParameter,
            {},
            "no-store",
        );
    } catch (error) {
        if (error?.status === 404 || error?.status === 400) {
            return;
        }
        throw error;
    }
};


replaceInChain(chain, RequestDataFromApi, RequestDataFromApiUpdated);



